module.exports = "<div *ngIf=\"isInProgress | async\" class=\"overlay\">\n  <mat-progress-spinner  class=\"spinner\" [color]=\"color\" [mode]=\"mode\" [value]=\"value\"></mat-progress-spinner>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/shared/progress-spinner/progress-spinner.component.html
// module id = ../../../../../src-admin/app/shared/progress-spinner/progress-spinner.component.html
// module chunks = main